import { lazy } from 'react'

import type { RouteObject } from 'react-router'

import { BuscarClientePageSuspense } from '@/shared/pages-suspense'

const SimuladorPage = lazy(() =>
  import('@/features/simulador/chile/pages/simulador').then((module) => ({ default: module.SimuladorPage })),
)

const SimuladorSalvarSimulacaoPage = lazy(() =>
  import('@/features/simulador/chile/pages/selecionar-cliente-simulacao').then((module) => ({
    default: module.SimuladorSalvarSimulacaoPage,
  })),
)

export const chileSimuladorRoutes: RouteObject[] = [
  {
    path: 'es-CL/simulador',
    children: [
      {
        index: true,
        element: <SimuladorPage />,
      },
      {
        path: ':salvar-simulacao',
        element: (
          <BuscarClientePageSuspense>
            <SimuladorSalvarSimulacaoPage />
          </BuscarClientePageSuspense>
        ),
      },
    ],
  },
]
